import { useEffect, useState } from "react";
import useUuid from "./uuid-hook";
import { IValidationGroup } from "./validation-group/validation-group-hook";

interface IInputValidationHookProps {
    value?: string | number | null;
    validationGroup?: IValidationGroup;
    required?: boolean;
    validationCallback?: () => IInputValitationResponse;
}

export interface IInputValitationResponse {
    isValid: boolean,
    messages: string[];
}

function isEmpty(val?: string | number | null): boolean {
    if (val === 0) return false;
    return !val || val.toString().trim() === "";
}

const useInputValidation = ({ value, validationGroup, required, validationCallback }: IInputValidationHookProps) => {
    const id = useUuid();
    const [isValid, setIsValid] = useState(true);

    useEffect(() => {
        let valid = true;
        /* consider custome validator from outside as callback */
        if (validationCallback !== undefined) {
            valid = validationCallback().isValid;
        }
        if (required && isEmpty(value)) {
            valid = false;
        }
        setIsValid(valid);

        /** update validation group */
        validationGroup?.update({ id, isValid: valid });
    }, [validationGroup, validationGroup?.shouldRevalidate, validationCallback, required, value, id])

    useEffect(() => {
        /** cleanup, remove validation state from group on component unmount */
        return () => validationGroup?.delete(id);
    }, [validationGroup, id])

    return isValid;
}

export default useInputValidation;
